import { Exception } from '../Exception';
export class AuthException extends Exception {
  constructor(message: string) {
    super(message);
  }
}
